import React from "react";
import { useTranslation } from "react-i18next";
import MDialog from "@/components/ui/atoms/MDialog";
import MLoader from "@/components/ui/atoms/MLoader";
import { MedicineInfo } from "@/types/pillbox";
import styles from "./MedicineAboutModal.module.css";

export interface MedicineAboutModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: boolean;
  info: MedicineInfo | null;
}

const MedicineAboutModal: React.FC<MedicineAboutModalProps> = ({
  open,
  onClose,
  loading,
  error,
  info,
}) => {
  const { t } = useTranslation();

  return (
    <MDialog
      isOpen={open}
      onClose={onClose}
      title={info?.title}
      showPrimaryCta={false}
    >
      {loading ? (
        <div className={styles.loaderWrap}>
          <MLoader />
        </div>
      ) : error ? (
        <p className={styles.error}>{t("pillbox.detail.aboutError")}</p>
      ) : (
        <>
          <p className={styles.body}>{info?.body}</p>
          <p className={styles.disclaimer}>
            {t("pillbox.detail.aboutDisclaimer")}
          </p>
        </>
      )}
    </MDialog>
  );
};

export default MedicineAboutModal;
